import React from 'react';
import ConditionalNavBar from "../components/ConditionalNavBar"
import HomeFormJSON from '../forms/HomeFormJSON';
import backgroundImg from '../assets/images/background.jpg';

// Content Section Component
const ContentSection = () => {
  return (
    <div style={{
      borderRadius: '10px',
      padding: '2rem',
      margin: '1rem 0'
    }}>
      <h1 style={{
        fontSize: '3.5rem',
        fontWeight: 'bold',
        marginBottom: '1rem',
        color: '#fff'
      }}>Welcome to JSON Property Search</h1>
      <p style={{
        fontSize: '1.2rem',
        lineHeight: '1.6',
        color: '#fff'
      }}>
        This is the JSON file-based property search version. Use this for testing and development purposes.
      </p>
      <p style={{
        fontSize: '1.2rem',
        lineHeight: '1.6',
        color: '#fff'
      }}>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
      </p>
      <p style={{
        fontSize: '1.2rem',
        lineHeight: '1.6',
        color: '#fff'
      }}>
        Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.
      </p>
    </div>
  );
};

// Main Homepage Component
const HomepageJSON = () => {
  return (
    <div>
      {/* Bootstrap 5 CSS Link */}
      <link 
        href="https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.3.0/css/bootstrap.min.css" 
        rel="stylesheet" 
      />
      
      {/* Custom CSS for mobile menu */}
      <style>{`
        /* Desktop/Tablet styles - normal navbar behavior */
        @media (min-width: 992px) {
          .navbar-collapse {
            background-color: transparent !important;
            position: static !important;
            box-shadow: none !important;
            border: none !important;
            padding: 0 !important;
            margin: 0 !important;
          }
          
          .navbar-nav {
            background-color: transparent !important;
          }
          
          .navbar-nav .nav-link {
            background-color: transparent !important;
          }
        }
        
        /* Mobile styles only */
        @media (max-width: 991.98px) {
          .navbar-collapse {
            background-color: white !important;
            border-top: 1px solid #dee2e6;
            margin-top: 0.5rem;
            padding: 0.5rem 0;
            box-shadow: 0 2px 10px rgba(0,0,0,0.1);
            border-radius: 0 0 8px 8px;
            position: absolute;
            top: 100%;
            left: 0;
            right: 0;
            z-index: 1000;
          }
          
          .navbar-nav {
            background-color: white !important;
          }
          
          .navbar-nav .nav-link {
            padding: 0.75rem 1rem !important;
            border-bottom: 1px solid #f8f9fa;
            background-color: white !important;
            color: black !important;
          }
          
          .navbar-nav .nav-link:hover {
            background-color: #f8f9fa !important;
            color: #333 !important;
          }
          
          .navbar {
            position: relative;
          }
        }
        
        .navbar-toggler:focus {
          box-shadow: none;
        }
        
        /* Only show mobile menu background when it's actually open on mobile */
        @media (max-width: 991.98px) {
          .navbar-collapse.show {
            background-color: white !important;
          }
        }
      `}</style>
      
      <div style={{ fontFamily: 'Arial, sans-serif' }}>
        {/* Navigation */}
        <ConditionalNavBar />

        {/* Hero Section */}
        <section style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url(${backgroundImg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          minHeight: 'calc(100vh - 80px)',
          display: 'flex',
          alignItems: 'center'
        }}>
          <div className="container">
            <div className="row">
              {/* Form Section (1/3) - Left side */}
              <div className="col-lg-4">
                <HomeFormJSON />
              </div>

              {/* Content Section (2/3) - Right side */}
              <div className="col-lg-8">
                <ContentSection />
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* Bootstrap 5 JS Bundle */}
      <script src="https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.3.0/js/bootstrap.bundle.min.js"></script>
    </div>
  );
};

export default HomepageJSON;
